import { render, staticRenderFns } from "./MoblieBottom.vue?vue&type=template&id=6573d036&scoped=true&"
import script from "./MoblieBottom.vue?vue&type=script&lang=js&"
export * from "./MoblieBottom.vue?vue&type=script&lang=js&"
import style0 from "./MoblieBottom.vue?vue&type=style&index=0&id=6573d036&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6573d036",
  null
  
)

export default component.exports